module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMjAiIGhlaWdodD0iMzIwIj48cGF0aCBmaWxsPSIjRDUyQjFFIiBkPSJNMCAwaDMyMHYzMjBIMHoiLz48cGF0aCBmaWxsPSIjZmZmIiBkPSJNNjAgMTMwaDIwMHY2MEg2MHoiLz48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMTMwIDYwaDYwdjIwMGgtNjB6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/che.svg
// module id = cDQn
// module chunks = 0